const { makeStyles } = require('@material-ui/core');

/** Cores principais do projeto */
const COLORS = {
  primary: '#003366',
  accent: '#FFCC00',
  grayDark: '#C0B8AB',
  grayLight: '#E6E1DB',
  textMuted: '#6B6560',
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    height: '100%',
  },
  dataContainer: {
    marginTop: 9,
    textAlign: 'center',
  },
  dataText: {
    fontSize: 10,
    fontFamily: 'Poppins',
    color: COLORS.textMuted,
  },
  itensMenu: {
    fontSize: 14,
    fontFamily: 'Poppins',
    color: COLORS.grayDark,
    width: 140,
  },
  imageSideBar: {
    width: 180,
    marginTop: 21,
    marginBottom: 21,
  },
  linkStyle: {
    textDecoration: 'none',
    color: COLORS.grayDark,
  },
  /** Link de menu lateral: inativo */
  navLink: {
    color: COLORS.textMuted,
    textDecoration: 'none',
    display: 'block',
    borderRadius: 8,
    margin: '2px 6px',
    transition:
      'background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease',
    '&:hover': {
      backgroundColor: COLORS.grayLight,
      color: COLORS.primary,
      '& .MuiListItemIcon-root': {
        color: COLORS.primary,
      },
      '& .sidebar-nav-img': {
        opacity: 1,
      },
    },
    '& .MuiListItemIcon-root': {
      color: COLORS.grayDark,
      minWidth: 40,
      transition: 'color 0.18s ease',
    },
    '& .MuiListItemText-primary': {
      fontSize: 14,
      fontFamily: 'Poppins',
      transition: 'color 0.18s ease, font-weight 0.18s ease',
    },
    '& .sidebar-nav-img': {
      opacity: 0.7,
      transition: 'opacity 0.18s ease',
    },
  },
  /** Rota ativa: azul + faixa amarela + fundo claro */
  navLinkActive: {
    color: `${COLORS.primary} !important`,
    fontWeight: 600,
    backgroundColor: 'rgba(0, 51, 102, 0.07)',
    boxShadow: `inset 3px 0 0 ${COLORS.accent}`,
    '&:hover': {
      backgroundColor: 'rgba(0, 51, 102, 0.11)',
      color: `${COLORS.primary} !important`,
      '& .MuiListItemIcon-root': {
        color: `${COLORS.primary} !important`,
      },
    },
    '& .MuiListItemIcon-root': {
      color: `${COLORS.primary} !important`,
    },
    '& .MuiListItemText-primary': {
      color: `${COLORS.primary} !important`,
      fontWeight: 600,
    },
    '& .sidebar-nav-img': {
      opacity: 1,
    },
  },
  /** Botão Sair: mesmo idioma visual */
  logoutItem: {
    color: COLORS.textMuted,
    borderRadius: 8,
    margin: '2px 6px',
    transition: 'background-color 0.18s ease, color 0.18s ease',
    '& .MuiListItemText-primary': {
      color: 'inherit',
      fontSize: 14,
      fontFamily: 'Poppins',
    },
    '&:hover': {
      backgroundColor: COLORS.grayLight,
      color: COLORS.primary,
    },
  },
  logoutIconImg: {
    opacity: 0.75,
  },
  icons: {
    fontSize: 22,
  },
  listItemCollapsed: {
    justifyContent: 'center',
    paddingLeft: 4,
    paddingRight: 4,
    '& .MuiListItemIcon-root': {
      minWidth: '0 !important',
      marginRight: '0 !important',
      justifyContent: 'center',
    },
  },
  listItemTextHidden: {
    display: 'none',
  },
}));

export default useStyles;
